


























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import { APP_CONFIG } from '@/config/app-config';
import authService from '@/services/auth-services';
import localStorage from '@/utility/localStorage';
import Notification from './Notification.vue';

@Component({
    components: {
        'notification': Notification
    }
})
export default class AppHeader extends Vue {
    private isOpenMenuUser = false;
    private totalNotify = 0;

    @Watch('userInfo', { immediate: true, deep: true })
    private async watchUserInfo() {
        if (this.userInfo && this.userInfo.userName) {
            this.$cookies.set('vtb_user', this.userInfo.userName, -1, '', this.isDepositSystem ? 'thongtintmdt.com' : 'viettaobao.vn'); 
        }
    }

    get isDepositSystem() {
        return APP_CONFIG.system_type !== 'order';
    }

    get main_domain() {
        return APP_CONFIG.system_type !== 'order' ? APP_CONFIG.settings.main_domain_deposit : APP_CONFIG.settings.main_domain;
    }

    get showMenuLeft() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo || {};
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo || {};
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDetail() {
        return (this.customerLevels || []).find((cl: any) => cl.ID === (this.customerInfo.LevelID || 1));
    }

    get isToken() {
        return authProvider.isToken();
    }

    get userAvatar() {
        if (this.userInfo && this.userInfo.userName) {
            return `https://ui-avatars.com/api/?name=${encodeURIComponent(this.userInfo.userName)}&background=ea580c&color=fff&bold=true`;
        }
        return 'assets/images/photos/loggeduser.png';
    }

    private onOpenUserMenu() {
        this.isOpenMenuUser = !this.isOpenMenuUser;
    }

    private onLogout() {
        this.$cookies.remove('vtb_user'); 
        (window['getApp'] as any).$emit('APP_LOGOUT');
    }

    private onToggleMenu() {
        (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', !this.showMenuLeft);
    }

    private getTotalNotification(total: number) {
        this.totalNotify = total;
    }
}
